/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';
import {
    type StationaryUnit,
    StationaryUnitFromJSON,
    StationaryUnitToJSON,
} from '../models/StationaryUnit';
import {
    type StationaryUnitCreate,
    StationaryUnitCreateFromJSON,
    StationaryUnitCreateToJSON,
} from '../models/StationaryUnitCreate';
import {
    type StationaryUnitSortKey,
    StationaryUnitSortKeyFromJSON,
    StationaryUnitSortKeyToJSON,
} from '../models/StationaryUnitSortKey';
import {
    type StationaryUnitUpdate,
    StationaryUnitUpdateFromJSON,
    StationaryUnitUpdateToJSON,
} from '../models/StationaryUnitUpdate';

export interface RoutesStationaryUnitsCreateStationaryUnitRequest {
    stationaryUnitCreate: StationaryUnitCreate;
}

export interface RoutesStationaryUnitsDeleteStationaryUnitRequest {
    stationaryUnitId: string;
}

export interface RoutesStationaryUnitsListStationaryUnitsRequest {
    pageSize: number;
    search?: string | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: StationaryUnitSortKey;
}

export interface RoutesStationaryUnitsListStationaryUnitsMetadataRequest {
    pageSize: number;
    search?: string | null;
}

export interface RoutesStationaryUnitsReadStationaryUnitRequest {
    stationaryUnitId: string;
}

export interface RoutesStationaryUnitsReadStationaryUnitByHardwareKeyRequest {
    hardwareKey: string;
}

export interface RoutesStationaryUnitsUpdateStationaryUnitRequest {
    stationaryUnitId: string;
    stationaryUnitUpdate: StationaryUnitUpdate;
}

export interface RoutesStationaryUnitsValidateCreateStationaryUnitRequest {
    stationaryUnitCreate: StationaryUnitCreate;
}

export interface RoutesStationaryUnitsValidateUpdateStationaryUnitRequest {
    stationaryUnitId: string;
    stationaryUnitUpdate: StationaryUnitUpdate;
}

/**
 * StationaryUnitsApi - interface
 * 
 * @export
 * @interface StationaryUnitsApiInterface
 */
export interface StationaryUnitsApiInterface {
    /**
     * Creates request options for routesStationaryUnitsCreateStationaryUnit without sending the request
     * @param {StationaryUnitCreate} stationaryUnitCreate 
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsCreateStationaryUnitRequestOpts(requestParameters: RoutesStationaryUnitsCreateStationaryUnitRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new stationary unit.
     * @summary Create a stationary unit
     * @param {StationaryUnitCreate} stationaryUnitCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsCreateStationaryUnitRaw(requestParameters: RoutesStationaryUnitsCreateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StationaryUnit>>;

    /**
     * Create a new stationary unit.
     * Create a stationary unit
     */
    routesStationaryUnitsCreateStationaryUnit(requestParameters: RoutesStationaryUnitsCreateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StationaryUnit>;

    /**
     * Creates request options for routesStationaryUnitsDeleteStationaryUnit without sending the request
     * @param {string} stationaryUnitId 
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsDeleteStationaryUnitRequestOpts(requestParameters: RoutesStationaryUnitsDeleteStationaryUnitRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the stationary unit with the given ID.
     * @summary Delete a stationary unit
     * @param {string} stationaryUnitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsDeleteStationaryUnitRaw(requestParameters: RoutesStationaryUnitsDeleteStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the stationary unit with the given ID.
     * Delete a stationary unit
     */
    routesStationaryUnitsDeleteStationaryUnit(requestParameters: RoutesStationaryUnitsDeleteStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for routesStationaryUnitsListStationaryUnits without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {StationaryUnitSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsListStationaryUnitsRequestOpts(requestParameters: RoutesStationaryUnitsListStationaryUnitsRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the stationary units present.  If `search` is specified, return values similar to the `serialNumber` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * @summary List stationary units
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {StationaryUnitSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsListStationaryUnitsRaw(requestParameters: RoutesStationaryUnitsListStationaryUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StationaryUnit>>>;

    /**
     * Lists all the stationary units present.  If `search` is specified, return values similar to the `serialNumber` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List stationary units
     */
    routesStationaryUnitsListStationaryUnits(requestParameters: RoutesStationaryUnitsListStationaryUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StationaryUnit>>;

    /**
     * Creates request options for routesStationaryUnitsListStationaryUnitsMetadata without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsListStationaryUnitsMetadataRequestOpts(requestParameters: RoutesStationaryUnitsListStationaryUnitsMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary Stationary unit listing metadata
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsListStationaryUnitsMetadataRaw(requestParameters: RoutesStationaryUnitsListStationaryUnitsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * Stationary unit listing metadata
     */
    routesStationaryUnitsListStationaryUnitsMetadata(requestParameters: RoutesStationaryUnitsListStationaryUnitsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for routesStationaryUnitsReadStationaryUnit without sending the request
     * @param {string} stationaryUnitId 
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsReadStationaryUnitRequestOpts(requestParameters: RoutesStationaryUnitsReadStationaryUnitRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the stationary unit specified by the given ID.
     * @summary Get a single stationary unit
     * @param {string} stationaryUnitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsReadStationaryUnitRaw(requestParameters: RoutesStationaryUnitsReadStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StationaryUnit>>;

    /**
     * Returns the stationary unit specified by the given ID.
     * Get a single stationary unit
     */
    routesStationaryUnitsReadStationaryUnit(requestParameters: RoutesStationaryUnitsReadStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StationaryUnit>;

    /**
     * Creates request options for routesStationaryUnitsReadStationaryUnitByHardwareKey without sending the request
     * @param {string} hardwareKey 
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsReadStationaryUnitByHardwareKeyRequestOpts(requestParameters: RoutesStationaryUnitsReadStationaryUnitByHardwareKeyRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the stationary unit specified by the given hardware key.
     * @summary Get a single stationary unit by hardware key
     * @param {string} hardwareKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsReadStationaryUnitByHardwareKeyRaw(requestParameters: RoutesStationaryUnitsReadStationaryUnitByHardwareKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StationaryUnit>>;

    /**
     * Returns the stationary unit specified by the given hardware key.
     * Get a single stationary unit by hardware key
     */
    routesStationaryUnitsReadStationaryUnitByHardwareKey(requestParameters: RoutesStationaryUnitsReadStationaryUnitByHardwareKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StationaryUnit>;

    /**
     * Creates request options for routesStationaryUnitsUpdateStationaryUnit without sending the request
     * @param {string} stationaryUnitId 
     * @param {StationaryUnitUpdate} stationaryUnitUpdate 
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsUpdateStationaryUnitRequestOpts(requestParameters: RoutesStationaryUnitsUpdateStationaryUnitRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the stationary unit specified by the given ID.
     * @summary Update stationary unit
     * @param {string} stationaryUnitId 
     * @param {StationaryUnitUpdate} stationaryUnitUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsUpdateStationaryUnitRaw(requestParameters: RoutesStationaryUnitsUpdateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StationaryUnit>>;

    /**
     * Update the stationary unit specified by the given ID.
     * Update stationary unit
     */
    routesStationaryUnitsUpdateStationaryUnit(requestParameters: RoutesStationaryUnitsUpdateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StationaryUnit>;

    /**
     * Creates request options for routesStationaryUnitsValidateCreateStationaryUnit without sending the request
     * @param {StationaryUnitCreate} stationaryUnitCreate 
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsValidateCreateStationaryUnitRequestOpts(requestParameters: RoutesStationaryUnitsValidateCreateStationaryUnitRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new stationary unit without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate a stationary unit
     * @param {StationaryUnitCreate} stationaryUnitCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsValidateCreateStationaryUnitRaw(requestParameters: RoutesStationaryUnitsValidateCreateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new stationary unit without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a stationary unit
     */
    routesStationaryUnitsValidateCreateStationaryUnit(requestParameters: RoutesStationaryUnitsValidateCreateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for routesStationaryUnitsValidateUpdateStationaryUnit without sending the request
     * @param {string} stationaryUnitId 
     * @param {StationaryUnitUpdate} stationaryUnitUpdate 
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsValidateUpdateStationaryUnitRequestOpts(requestParameters: RoutesStationaryUnitsValidateUpdateStationaryUnitRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for updating the given stationary unit, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate stationary unit update
     * @param {string} stationaryUnitId 
     * @param {StationaryUnitUpdate} stationaryUnitUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof StationaryUnitsApiInterface
     */
    routesStationaryUnitsValidateUpdateStationaryUnitRaw(requestParameters: RoutesStationaryUnitsValidateUpdateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for updating the given stationary unit, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate stationary unit update
     */
    routesStationaryUnitsValidateUpdateStationaryUnit(requestParameters: RoutesStationaryUnitsValidateUpdateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class StationaryUnitsApi extends runtime.BaseAPI implements StationaryUnitsApiInterface {

    /**
     * Creates request options for routesStationaryUnitsCreateStationaryUnit without sending the request
     */
    async routesStationaryUnitsCreateStationaryUnitRequestOpts(requestParameters: RoutesStationaryUnitsCreateStationaryUnitRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['stationaryUnitCreate'] == null) {
            throw new runtime.RequiredError(
                'stationaryUnitCreate',
                'Required parameter "stationaryUnitCreate" was null or undefined when calling routesStationaryUnitsCreateStationaryUnit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stationary_units/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StationaryUnitCreateToJSON(requestParameters['stationaryUnitCreate']),
        };
    }

    /**
     * Create a new stationary unit.
     * Create a stationary unit
     */
    async routesStationaryUnitsCreateStationaryUnitRaw(requestParameters: RoutesStationaryUnitsCreateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StationaryUnit>> {
        const requestOptions = await this.routesStationaryUnitsCreateStationaryUnitRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StationaryUnitFromJSON(jsonValue));
    }

    /**
     * Create a new stationary unit.
     * Create a stationary unit
     */
    async routesStationaryUnitsCreateStationaryUnit(requestParameters: RoutesStationaryUnitsCreateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StationaryUnit> {
        const response = await this.routesStationaryUnitsCreateStationaryUnitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for routesStationaryUnitsDeleteStationaryUnit without sending the request
     */
    async routesStationaryUnitsDeleteStationaryUnitRequestOpts(requestParameters: RoutesStationaryUnitsDeleteStationaryUnitRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['stationaryUnitId'] == null) {
            throw new runtime.RequiredError(
                'stationaryUnitId',
                'Required parameter "stationaryUnitId" was null or undefined when calling routesStationaryUnitsDeleteStationaryUnit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stationary_units/{stationary_unit_id}`;
        urlPath = urlPath.replace('{stationary_unit_id}', encodeURIComponent(String(requestParameters['stationaryUnitId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the stationary unit with the given ID.
     * Delete a stationary unit
     */
    async routesStationaryUnitsDeleteStationaryUnitRaw(requestParameters: RoutesStationaryUnitsDeleteStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.routesStationaryUnitsDeleteStationaryUnitRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the stationary unit with the given ID.
     * Delete a stationary unit
     */
    async routesStationaryUnitsDeleteStationaryUnit(requestParameters: RoutesStationaryUnitsDeleteStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.routesStationaryUnitsDeleteStationaryUnitRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for routesStationaryUnitsListStationaryUnits without sending the request
     */
    async routesStationaryUnitsListStationaryUnitsRequestOpts(requestParameters: RoutesStationaryUnitsListStationaryUnitsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling routesStationaryUnitsListStationaryUnits().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stationary_units/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the stationary units present.  If `search` is specified, return values similar to the `serialNumber` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List stationary units
     */
    async routesStationaryUnitsListStationaryUnitsRaw(requestParameters: RoutesStationaryUnitsListStationaryUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StationaryUnit>>> {
        const requestOptions = await this.routesStationaryUnitsListStationaryUnitsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StationaryUnitFromJSON));
    }

    /**
     * Lists all the stationary units present.  If `search` is specified, return values similar to the `serialNumber` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List stationary units
     */
    async routesStationaryUnitsListStationaryUnits(requestParameters: RoutesStationaryUnitsListStationaryUnitsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StationaryUnit>> {
        const response = await this.routesStationaryUnitsListStationaryUnitsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for routesStationaryUnitsListStationaryUnitsMetadata without sending the request
     */
    async routesStationaryUnitsListStationaryUnitsMetadataRequestOpts(requestParameters: RoutesStationaryUnitsListStationaryUnitsMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling routesStationaryUnitsListStationaryUnitsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stationary_units/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * Stationary unit listing metadata
     */
    async routesStationaryUnitsListStationaryUnitsMetadataRaw(requestParameters: RoutesStationaryUnitsListStationaryUnitsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.routesStationaryUnitsListStationaryUnitsMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * Stationary unit listing metadata
     */
    async routesStationaryUnitsListStationaryUnitsMetadata(requestParameters: RoutesStationaryUnitsListStationaryUnitsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.routesStationaryUnitsListStationaryUnitsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for routesStationaryUnitsReadStationaryUnit without sending the request
     */
    async routesStationaryUnitsReadStationaryUnitRequestOpts(requestParameters: RoutesStationaryUnitsReadStationaryUnitRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['stationaryUnitId'] == null) {
            throw new runtime.RequiredError(
                'stationaryUnitId',
                'Required parameter "stationaryUnitId" was null or undefined when calling routesStationaryUnitsReadStationaryUnit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stationary_units/{stationary_unit_id}`;
        urlPath = urlPath.replace('{stationary_unit_id}', encodeURIComponent(String(requestParameters['stationaryUnitId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the stationary unit specified by the given ID.
     * Get a single stationary unit
     */
    async routesStationaryUnitsReadStationaryUnitRaw(requestParameters: RoutesStationaryUnitsReadStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StationaryUnit>> {
        const requestOptions = await this.routesStationaryUnitsReadStationaryUnitRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StationaryUnitFromJSON(jsonValue));
    }

    /**
     * Returns the stationary unit specified by the given ID.
     * Get a single stationary unit
     */
    async routesStationaryUnitsReadStationaryUnit(requestParameters: RoutesStationaryUnitsReadStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StationaryUnit> {
        const response = await this.routesStationaryUnitsReadStationaryUnitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for routesStationaryUnitsReadStationaryUnitByHardwareKey without sending the request
     */
    async routesStationaryUnitsReadStationaryUnitByHardwareKeyRequestOpts(requestParameters: RoutesStationaryUnitsReadStationaryUnitByHardwareKeyRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['hardwareKey'] == null) {
            throw new runtime.RequiredError(
                'hardwareKey',
                'Required parameter "hardwareKey" was null or undefined when calling routesStationaryUnitsReadStationaryUnitByHardwareKey().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stationary_units/by/hardware_key/{hardware_key}`;
        urlPath = urlPath.replace('{hardware_key}', encodeURIComponent(String(requestParameters['hardwareKey'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the stationary unit specified by the given hardware key.
     * Get a single stationary unit by hardware key
     */
    async routesStationaryUnitsReadStationaryUnitByHardwareKeyRaw(requestParameters: RoutesStationaryUnitsReadStationaryUnitByHardwareKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StationaryUnit>> {
        const requestOptions = await this.routesStationaryUnitsReadStationaryUnitByHardwareKeyRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StationaryUnitFromJSON(jsonValue));
    }

    /**
     * Returns the stationary unit specified by the given hardware key.
     * Get a single stationary unit by hardware key
     */
    async routesStationaryUnitsReadStationaryUnitByHardwareKey(requestParameters: RoutesStationaryUnitsReadStationaryUnitByHardwareKeyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StationaryUnit> {
        const response = await this.routesStationaryUnitsReadStationaryUnitByHardwareKeyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for routesStationaryUnitsUpdateStationaryUnit without sending the request
     */
    async routesStationaryUnitsUpdateStationaryUnitRequestOpts(requestParameters: RoutesStationaryUnitsUpdateStationaryUnitRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['stationaryUnitId'] == null) {
            throw new runtime.RequiredError(
                'stationaryUnitId',
                'Required parameter "stationaryUnitId" was null or undefined when calling routesStationaryUnitsUpdateStationaryUnit().'
            );
        }

        if (requestParameters['stationaryUnitUpdate'] == null) {
            throw new runtime.RequiredError(
                'stationaryUnitUpdate',
                'Required parameter "stationaryUnitUpdate" was null or undefined when calling routesStationaryUnitsUpdateStationaryUnit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stationary_units/{stationary_unit_id}`;
        urlPath = urlPath.replace('{stationary_unit_id}', encodeURIComponent(String(requestParameters['stationaryUnitId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StationaryUnitUpdateToJSON(requestParameters['stationaryUnitUpdate']),
        };
    }

    /**
     * Update the stationary unit specified by the given ID.
     * Update stationary unit
     */
    async routesStationaryUnitsUpdateStationaryUnitRaw(requestParameters: RoutesStationaryUnitsUpdateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StationaryUnit>> {
        const requestOptions = await this.routesStationaryUnitsUpdateStationaryUnitRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StationaryUnitFromJSON(jsonValue));
    }

    /**
     * Update the stationary unit specified by the given ID.
     * Update stationary unit
     */
    async routesStationaryUnitsUpdateStationaryUnit(requestParameters: RoutesStationaryUnitsUpdateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StationaryUnit> {
        const response = await this.routesStationaryUnitsUpdateStationaryUnitRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for routesStationaryUnitsValidateCreateStationaryUnit without sending the request
     */
    async routesStationaryUnitsValidateCreateStationaryUnitRequestOpts(requestParameters: RoutesStationaryUnitsValidateCreateStationaryUnitRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['stationaryUnitCreate'] == null) {
            throw new runtime.RequiredError(
                'stationaryUnitCreate',
                'Required parameter "stationaryUnitCreate" was null or undefined when calling routesStationaryUnitsValidateCreateStationaryUnit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stationary_units/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StationaryUnitCreateToJSON(requestParameters['stationaryUnitCreate']),
        };
    }

    /**
     * Validate data for a new stationary unit without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a stationary unit
     */
    async routesStationaryUnitsValidateCreateStationaryUnitRaw(requestParameters: RoutesStationaryUnitsValidateCreateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.routesStationaryUnitsValidateCreateStationaryUnitRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new stationary unit without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a stationary unit
     */
    async routesStationaryUnitsValidateCreateStationaryUnit(requestParameters: RoutesStationaryUnitsValidateCreateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.routesStationaryUnitsValidateCreateStationaryUnitRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for routesStationaryUnitsValidateUpdateStationaryUnit without sending the request
     */
    async routesStationaryUnitsValidateUpdateStationaryUnitRequestOpts(requestParameters: RoutesStationaryUnitsValidateUpdateStationaryUnitRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['stationaryUnitId'] == null) {
            throw new runtime.RequiredError(
                'stationaryUnitId',
                'Required parameter "stationaryUnitId" was null or undefined when calling routesStationaryUnitsValidateUpdateStationaryUnit().'
            );
        }

        if (requestParameters['stationaryUnitUpdate'] == null) {
            throw new runtime.RequiredError(
                'stationaryUnitUpdate',
                'Required parameter "stationaryUnitUpdate" was null or undefined when calling routesStationaryUnitsValidateUpdateStationaryUnit().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stationary_units/{stationary_unit_id}/validate`;
        urlPath = urlPath.replace('{stationary_unit_id}', encodeURIComponent(String(requestParameters['stationaryUnitId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: StationaryUnitUpdateToJSON(requestParameters['stationaryUnitUpdate']),
        };
    }

    /**
     * Validate data for updating the given stationary unit, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate stationary unit update
     */
    async routesStationaryUnitsValidateUpdateStationaryUnitRaw(requestParameters: RoutesStationaryUnitsValidateUpdateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.routesStationaryUnitsValidateUpdateStationaryUnitRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for updating the given stationary unit, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate stationary unit update
     */
    async routesStationaryUnitsValidateUpdateStationaryUnit(requestParameters: RoutesStationaryUnitsValidateUpdateStationaryUnitRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.routesStationaryUnitsValidateUpdateStationaryUnitRaw(requestParameters, initOverrides);
    }

}
